import React, { ReactElement } from "react";
import { Table } from "antd";
import { UnfulfilledAdsOver20HoursRecord } from "../../../redux/types/reportTypes";

export const columns = [
  {
    title: "Publisher",
    dataIndex: "publisher",
  },
  {
    title: "Cluster Id",
    dataIndex: "cluster_id",
  },
  {
    title: "Origami Ad Uuid",
    dataIndex: "origami_ad_uuid",
  },
  {
    title: "Marketplace Url",
    dataIndex: "marketplace_url",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
  },
  {
    title: "End Date",
    dataIndex: "end_date",
  },
  {
    title: "State",
    dataIndex: "state",
  },
];

type UnfulfilledAdsOver20HoursProps = {
  loading: boolean;
  records: Array<UnfulfilledAdsOver20HoursRecord>;
};

const UnfulfilledAdsOver20HoursTable = ({ loading, records }: UnfulfilledAdsOver20HoursProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="publisher"
    pagination={false}
    scroll={{ y: 350, x: 3200 }}
  />
);

export default UnfulfilledAdsOver20HoursTable;
